import { useContext, useState } from "react"

import { useQuery } from "@apollo/client"
// queries
import { GET_SAVED_BLOCKS_BY_SELECTED_STAFF } from "./queries"
import StaffSidebar from "../../components/StaffSidebar"
import SupervisorName from "../../components/SupervisorName"
import _ from "lodash"
// Context
import { UserContext } from "../../context/userContext"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { LoaderMedium } from "../../components/Loaders"

import styles from "../../styles/Page-Engagements.module.css"

export default function SupervisionPlan() {
  const userCtx = useContext(UserContext)
  const staff_id = userCtx.session.user.staff_id
  const [dataSession, setDataSession] = useState(null)
  const [professionalGoals, setProfessionalGoals] = useState(null)
  const [supervisionGoals, setSupervisionGoals] = useState(null)

  const { loading } = useQuery(GET_SAVED_BLOCKS_BY_SELECTED_STAFF, {
    variables: {
      staff_id,
      idTemplate: "individual_supervision_session",
      organization_id: userCtx.session.user.organization_id,
      staff_selector_id: staff_id,
      groupByIdStamp: true,
    },
    skip: !staff_id,
    fetchPolicy: "network-only",
    onCompleted: ({ TemplateSavedByStaffIdSelector }) => {
      const dataParse = !_.isEmpty(TemplateSavedByStaffIdSelector)
        ? JSON.parse(TemplateSavedByStaffIdSelector?.data)
        : {}

      setDataSession(dataParse)

      for (
        var i = 0;
        i <
        dataParse.session__supervision__supervision_plan.values
          .professional_goals.length;
        i++
      ) {
        let task = ""

        for (
          var i2 = 0;
          i2 <
          dataParse.session__supervision__supervision_plan.values
            .professional_goals[i].professional_goals_tasks.length;
          i2++
        ) {
          task +=
            dataParse.session__supervision__supervision_plan.values
              .professional_goals[i].professional_goals_tasks[i2].task + ", "
        }

        dataParse.session__supervision__supervision_plan.values.professional_goals[
          i
        ].task = task.slice(0, -2)
      }

      setProfessionalGoals(
        dataParse.session__supervision__supervision_plan.values
          .professional_goals
      )

      for (
        var y = 0;
        y <
        dataParse.session__supervision__supervision_plan.values
          .supervision_goals.length;
        y++
      ) {
        let taskSS = ""

        for (
          var y2 = 0;
          y2 <
          dataParse.session__supervision__supervision_plan.values
            .supervision_goals[y].supervision_goals_tasks.length;
          y2++
        ) {
          taskSS +=
            dataParse.session__supervision__supervision_plan.values
              .supervision_goals[y].supervision_goals_tasks[y2].task + ", "
        }

        dataParse.session__supervision__supervision_plan.values.supervision_goals[
          y
        ].task = taskSS.slice(0, -2)
      }

      setSupervisionGoals(
        dataParse.session__supervision__supervision_plan.values
          .supervision_goals
      )
    },
  })

  const htmlClean = (rowData) => {
    return rowData.goal.replace(/<\/?[^>]+(>|$)/g, "")
  }

  if (loading) return <LoaderMedium />

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar s">
        <StaffSidebar />
      </div>
      <div className="main-content">
        <div>
          <div>
            <br></br>
            <h1 className={styles.title}>Supervision Plan</h1>
            <ul className={styles.cta}>
              <li>
                <button className="btn">Print Supervision Plan</button>
              </li>
            </ul>
            <br></br>
            <div className={styles.summaryTop}>
              <div>
                <h3>Supervision Frequency</h3>
                <span>
                  {" "}
                  {!_.isEmpty(dataSession)
                    ? dataSession.session__supervision__supervision_plan?.values
                        ?.supervision_plan_review_frequency
                    : "N/A"}
                </span>
              </div>
              <div>
                <h3>Primary Supervisor</h3>
                <span>
                  {
                    <SupervisorName
                      staff_id={
                        !_.isEmpty(dataSession)
                          ? dataSession.session.staff_id
                          : ""
                      }
                      organization_id={
                        !_.isEmpty(dataSession)
                          ? dataSession.session.organization_id
                          : ""
                      }
                    />
                  }
                </span>
              </div>
            </div>
            <div className={styles.summaryContent}>
              <div className={styles.colLeft}>
                <h4>Strenghts</h4>
              </div>
              <div className={styles.colRight}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: !_.isEmpty(dataSession)
                      ? dataSession.session__supervision__supervision_plan
                          ?.values?.supervision_plan_strengths
                      : "N/A",
                  }}
                />
              </div>
              <div className={styles.colLeft}>
                <h4>5-year Goal</h4>
              </div>
              <div className={styles.colRight}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: !_.isEmpty(dataSession)
                      ? dataSession.session__supervision__supervision_plan
                          ?.values?.supervision_plan_five_year
                      : "N/A",
                  }}
                />
              </div>
              <div className={styles.colLeft}>
                <h4 style={{ textAlign: "center" }}>
                  Organizational Support Desired
                </h4>
              </div>
              <div className={styles.colRight}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: !_.isEmpty(dataSession)
                      ? _.map(
                          _.flatten(
                            dataSession.session__supervision__supervision_plan
                              ?.values?.supervision_plan_support
                          ),
                          "support_item"
                        ).join(", ")
                      : "N/A",
                  }}
                />
              </div>
            </div>
            <h2>Profesional Goals</h2>
            <DataTable
              value={!_.isEmpty(professionalGoals) ? professionalGoals : {}}
              responsiveLayout="scroll"
              className="table-data"
              sortField="goal"
              sortOrder={1}
            >
              <Column
                style={{ width: "33%" }}
                field="goal"
                header="Goals"
                body={htmlClean}
              />
              <Column
                style={{ width: "33%" }}
                field="goal_status"
                header="Status"
              />
              <Column
                style={{ width: "33%" }}
                field="task"
                header="Goal Tasks"
              />
            </DataTable>
            <h2>Supervision Goals</h2>
            <DataTable
              className="table-data"
              value={!_.isEmpty(supervisionGoals) ? supervisionGoals : {}}
              responsiveLayout="scroll"
              sortField="goal"
              sortOrder={1}
            >
              <Column
                style={{ width: "33%" }}
                field="goal"
                header="Goals"
                body={htmlClean}
              />
              <Column
                style={{ width: "33%" }}
                field="goal_status"
                header="Status"
              />
              <Column
                style={{ width: "33%" }}
                field="task"
                header="Goal Tasks"
              />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  )
}
